module.exports = __webpack_public_path__ + "img/FDA.afde5c51.png";